import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultSoftDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 48,
	viewBox: "0 0 64 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M34 4.5C42.5755 4.5 49.5 11.2306 49.5 19.5C49.5 27.7694 42.5755 34.5 34 34.5C25.4245 34.5 18.5 27.7694 18.5 19.5C18.5 11.2306 25.4245 4.5 34 4.5Z",
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34,
			cy: 20,
			r: 15.5,
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.4908 30C48.2139 30.3453 47.923 30.679 47.619 31H57C59.2091 31 61 29.2091 61 27V11C61 8.79086 59.2091 7 57 7H45.3295C45.7642 7.31257 46.1827 7.64641 46.5833 8H57C58.6569 8 60 9.34315 60 11V27C60 28.6569 58.6569 30 57 30H48.4908Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 32V33C6 35.2091 7.79086 37 10 37H54C56.2091 37 58 35.2091 58 33V32H57V33C57 34.6569 55.6569 36 54 36H10C8.34315 36 7 34.6569 7 33V32H6Z",
			fill: "white",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6706 7H7C4.79086 7 3 8.79086 3 11V27C3 29.2091 4.79086 31 7 31H20.381C20.077 30.679 19.7861 30.3453 19.5093 30H7C5.34315 30 4 28.6569 4 27V11C4 9.34315 5.34315 8 7 8H21.4167C21.8173 7.64641 22.2358 7.31257 22.6706 7Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56.2943 40.3792L48.5161 32.601C48.1256 32.2105 47.4924 32.2105 47.1019 32.601C46.7114 32.9915 46.7114 33.6247 47.1019 34.0152L54.8801 41.7934C55.2706 42.1839 55.9038 42.1839 56.2943 41.7934C56.6848 41.4029 56.6848 40.7697 56.2943 40.3792ZM46.3948 31.8939C45.6138 32.6749 45.6138 33.9413 46.3948 34.7223L54.173 42.5005C54.954 43.2815 56.2204 43.2815 57.0014 42.5005C57.7825 41.7194 57.7825 40.4531 57.0014 39.6721L49.2232 31.8939C48.4422 31.1128 47.1759 31.1128 46.3948 31.8939Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54 40.5L54.5 39.5",
			stroke: "#8588D8",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.5 39L53 38",
			stroke: "#8588D8",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.4009 23.6989C33.947 23.7795 34.3248 24.2881 34.2442 24.8342C34.1636 25.3803 33.655 25.7581 33.109 25.6775C32.5629 25.5969 32.1851 25.0883 32.2657 24.5422C32.3462 23.9961 32.8548 23.6183 33.4009 23.6989ZM35.0554 12.487C37.241 12.8095 38.7511 14.8424 38.4286 17.0281C38.2179 18.4559 37.6118 19.1246 36.1859 20.0147C34.7557 20.9068 34.4208 21.354 34.2551 22.4772L32.936 22.2826C33.1768 20.6509 33.8147 19.9222 35.4801 18.8835C36.6061 18.181 36.97 17.7792 37.1095 16.8334C37.3246 15.3759 36.3183 14.0211 34.8607 13.806C33.4032 13.591 32.0484 14.5973 31.8333 16.0549L31.736 16.7144L30.417 16.5198L30.5143 15.8602C30.8368 13.6746 32.8697 12.1645 35.0554 12.487Z",
			fill: "#8588D8"
		})
	]
});
export default SvgNoResultSoftDark;
